import { IntegrationContainerImageScannerNirvanaDataProvider } from '../dataProvider/IntegrationContainerImageScannerNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class IntegrationContainerImageScannerDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrationContainerImageScannerNirvanaDataProvider);
  }
}
